'use client';

import React from 'react';
import { useCart } from '../../hooks/useCart';
import { CartContext } from './CartContext';

export const CartProvider = ({ children }) => (
  <CartContext.Provider value={useCart()}>{children}</CartContext.Provider>
);
